var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 700,
    viewBox: "0 0 1440 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_185_286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 700
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 700,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_185_286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 700,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 172,
    r: 24,
    fill: "#00FFB2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1084,
    cy: 172,
    r: 24,
    fill: "#00E0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: -6,
    width: 356,
    height: 178,
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654,
    y: 172,
    width: 356,
    height: 178,
    transform: "rotate(90 654 172)",
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298 528V350L120 350L120 528V706H298H476V528H298Z",
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 622,
    r: 24,
    fill: "#4324FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1544,
    y: 172,
    width: 356,
    height: 178,
    transform: "rotate(90 1544 172)",
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1366,
    y: 706,
    width: 356,
    height: 178,
    transform: "rotate(-180 1366 706)",
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010 350L1188 350L1188 172L1010 172L832 172L832 350L832 528L1010 528L1010 350Z",
    fill: "#F8F8FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadbg);
export default __webpack_public_path__ + "static/media/headbg.bd58b1b68a3d657dbe367fcd04a1440e.svg";
export { ForwardRef as ReactComponent };